/* eslint-disable */
import * as React from "react";
import { SlideContext } from "../Context";
import { ComponentSourcetitle } from "../../../components/ComponentSourcetitle";
import { ComponentPreloader } from "../../../components/ComponentPreloader";
import { useChartCommoditiesData } from "../data/useChartCommoditiesData";
import { useChartIndexData } from "../data/useChartIndexData";
import { useHighchartTransformer } from "../transformers/useHighchartTransformer";
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";
import HighchartsChart from "../../../../charts/components/HighchartsChart";
import { ComponentContextReadyState } from "@sa/rep-core";
import { ComponentFootnote } from "../../../components/ComponentFootnote";
import { useParameter, useSubscriptionSource } from "../../../shared";
import { useExportSource } from "../hooks/useExportSource";

export const ComponentChart: React.FC<{ context: SlideContext }> = (props) => {
  const context = props.context;
  const olapResultCommodities = useHookSubscribe(null, context.olapResultChartCommodities$);
  const olapResultIndex = useHookSubscribe(null, context.olapResultChartIndex$);
  const source = useHookSubscribe(null, context.sources$);
  const loading = useHookSubscribe(null, context.loading$);
  useExportSource(source);
  useSubscriptionSource(source);

  const chartCommoditiesData = useChartCommoditiesData(olapResultCommodities);
  const chartIndexData = useChartIndexData(olapResultIndex);
  const highchartData = useHighchartTransformer(chartCommoditiesData, chartIndexData);

  if (window["exportMode"]) {
    window["exportReady"] = !loading;
  }

  if (loading) {
    return <ComponentPreloader />;
  }
  return (
    <>
      <ComponentSourcetitle>Source: {source}</ComponentSourcetitle>
      <ComponentFootnote>%</ComponentFootnote>
      <HighchartsChart data={highchartData} loader={<ComponentPreloader />} />
    </>
  );
};
